// Since the domain is different depending on the LGWAN and the Internet,
// it is dynamically determined from location.origin.
export const VITE_API_URL: string =
  import.meta.env.VITE_API_URL || location.origin;
export const VITE_APP_BASENAME: string =
  import.meta.env.VITE_APP_BASENAME || '';
export const VITE_DATADOG_ENV: string =
  import.meta.env.VITE_DATADOG_ENV || 'unknown';
export const VITE_RELEASE_VERSION: string =
  import.meta.env.VITE_RELEASE_VERSION || 'unknown';
export const VITE_ENV_NAME:
  | 'mock'
  | 'local'
  | 'dev'
  | 'stg'
  | 'prod'
  | 'unknown' = import.meta.env.VITE_ENV_NAME || 'unknown';

export const VITE_IS_PUBLIC_SITE: string = import.meta.env.VITE_IS_PUBLIC_SITE;
export const VITE_MOCK_ENABLED: string = import.meta.env.VITE_MOCK_ENABLED;
export const VITE_PRODUCT_NAME: string = import.meta.env.VITE_PRODUCT_NAME;
